import { render, staticRenderFns } from "./mfe_promissory_note.vue?vue&type=template&id=ba2f44c8&"
import script from "./mfe_promissory_note.vue?vue&type=script&lang=js&"
export * from "./mfe_promissory_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports